import { createContext, useContext } from 'react';

import { ModalContextValue } from './types';

export const UnifiedModalContext = createContext<ModalContextValue | null>(null);

export const useModalContext = (): ModalContextValue => {
  const ctx = useContext(UnifiedModalContext);
  if (!ctx) {
    throw new Error('Modal compound components must be used within <UnifiedModal>');
  }
  return ctx;
};
